import { render, staticRenderFns } from "./ModalPlan.vue?vue&type=template&id=3ff1dbc4&scoped=true&"
import script from "./ModalPlan.vue?vue&type=script&lang=js&"
export * from "./ModalPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1dbc4",
  null
  
)

export default component.exports